import React, {useState} from "react";
import {StyledCreateCumboModal} from "./CreateCumboModal.style";
import ComboDetails from "./ComboDetails";
import SelectItems from "./SelectItems";
import PricingOffers from "./PricingOffers/PricingOffers";
import Availability from "./Availability";
import ReviewSave from "./ReviewSave";

const tabs = ["Combo Details", "Select Items", "Pricing & Offers", "Availability", "Review & Save"];

const CreateCumboModal = ({setSuccessModal, onClose}) => {
    const [activeTab, setActiveTab] = useState(0);
    const [formData, setFormData] = useState({
        form1: null,
        form2: null,
        form3: null,
        form4: null,
        form5: null,
    });

    return (
        <StyledCreateCumboModal>
            <ul className="tab-wrap">
                {tabs?.map((data, index) => (
                    <li key={index} className={activeTab >= index ? "active" : ""}>
                        {data}
                    </li>
                ))}
            </ul>
            <span className="step-desc">
                Step {activeTab + 1} of 5: {activeTab === 0 && "Basic information about your combo"}
                {activeTab === 1 && "Choose items to include in the combo"}
                {activeTab === 2 && "Set pricing and savings"}
                {activeTab === 3 && "When and how the combo is available"}
                {activeTab === 4 && "Review your combo before saving"}
            </span>
            {activeTab === 0 && (
                <ComboDetails formData={formData} setFormData={setFormData} setActiveTab={setActiveTab} />
            )}
            {activeTab === 1 && (
                <SelectItems formData={formData} setFormData={setFormData} setActiveTab={setActiveTab} />
            )}
            {activeTab === 2 && (
                <PricingOffers formData={formData} setFormData={setFormData} setActiveTab={setActiveTab} />
            )}
            {activeTab === 3 && (
                <Availability formData={formData} setFormData={setFormData} setActiveTab={setActiveTab} />
            )}
            {activeTab === 4 && (
                <ReviewSave
                    setSuccessModal={setSuccessModal}
                    onClose={onClose}
                    formData={formData}
                    setActiveTab={setActiveTab}
                />
            )}
        </StyledCreateCumboModal>
    );
};

export default CreateCumboModal;
